import { Component, OnInit, OnDestroy, ViewChild, ElementRef, EventEmitter, ChangeDetectorRef, Output,} from '@angular/core';
import { Logger } from '../../../../../../core/logger/logger.service';
import { ApiHandlerService } from '../../../../../../core/api-handlers';
import { SubSink } from 'subsink';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { HotelService } from '../../../../hotel.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { tap } from 'rxjs/operators';
import { UtilityService } from '../../../../../../core/services/utility.service';
import * as moment from 'moment';
import { PlatformLocation } from '@angular/common';
import { Options } from '@angular-slider/ngx-slider';
import { AppGlobal } from 'projects/b2c/src/app/app.global';


const log = new Logger('hotel/HotelSearchFormComponent');

export interface LocationI {
    cityId: string;
    cityName: string;
    countryCode: string;
    status: boolean;
    source: string;
}
export let browserRefresh = false;

@Component({
    selector: 'app-hotel-search-form',
    templateUrl: './hotel-search-form.component.html',
    styleUrls: ['./hotel-search-form.component.scss']
})
export class HotelSearchFormComponent implements OnInit, OnDestroy {

    
    @ViewChild('destination_name', { static: false }) destination_name: ElementRef<HTMLElement>;
    @ViewChild('checkinDate', { static: false }) checkinDate: ElementRef<HTMLElement>;
    @ViewChild('checkoutDate', { static: false }) checkoutDate: ElementRef<HTMLElement>;
    isCollapsed = false;
    
    private subSunk = new SubSink();
    priceForm: FormGroup;
    max: number = 1;
    min: number = 0;
    sliderRange: Array<number> = [0, 1];
    stepRange = [this.min, this.max];
    regConfig: FormGroup;
    submitted: boolean = false;
    locations: LocationI[] = [];
    lastKeyupTstamp: number = 0;
    openRooms: boolean = false;
    adults: number[] = [1];
    childs: number[] = [0];
    noOfRooms: any = 1;
    noOfAdults: any = 1;
    noOfChild: any = 0;
    minDate = new Date();
    isOpen = false as boolean;
    bsDateConf: Partial<BsDatepickerConfig> = {
        isAnimated: true,
        dateInputFormat: 'DD-MM-YYYY',
        rangeInputFormat: 'DD-MM-YYYY',
        showWeekNumbers: false,
        containerClass: 'theme-blue',
    };
    city: LocationI;
    isLoading: boolean = false;
    guestCountData: {} = {};
    setMinDate: any;
    countries: any = [];
    roomError = false;
    travellerCountError = false;
    starRating: number = 0;
    minValue: number = 0;
    maxValue: number = 0;
    minPrice: any;
    maxPrice: any;
    options: Options = {
      floor: 0,
      ceil: 50000,
    };

    submitSessionHotelSearchKeyCheck: any;
    travellersFadeinn: any;
    @Output() callResult = new EventEmitter<any>();
    booking_source: any;
    public browserRefresh: boolean;
    mobileFrom:boolean=false;
    validationMsg: string;
    isValidLocation: boolean = false;
  
    constructor(
        private apiHandlerService: ApiHandlerService,
        private fb: FormBuilder,
        private router: Router,
        private hotelService: HotelService,
        private ngxService: NgxUiLoaderService,
        private util: UtilityService,
        private cdr: ChangeDetectorRef,
        public location: PlatformLocation,
        private appGlobal: AppGlobal
    ) {
        this.minDate = new Date();
        this.minDate.setDate(this.minDate.getDate());
    }
    

    ngOnInit(): void {
        this.hotelService.countryList.subscribe(res => {
            this.countries = res;
        });
        this.createForm();
        this.setModifySearch();
        this.onValueChange();
    }

    createForm(): void {
        this.regConfig = this.fb.group({
            cityName: new FormControl('', [Validators.required]),
            checkin: new FormControl('', [Validators.required]),
            checkout: new FormControl('', [Validators.required]),
            checkinDate: new FormControl(''),
            traveller: this.fb.array([this.createTravellerForm()]),
            market:['IND',[Validators.required]],
            destination_id: [''],
            destination_source: [''],
            rate:  new FormControl(''),
            fromPrice:  new FormControl(''),  
            toPrice:  new FormControl(''),
            
        })
    }

    openCity(): void {
        const w = document.documentElement.clientWidth;
        const breakpoint = 992;
        console.log(w);
        if (w < breakpoint) {
          this.mobileFrom = true;
        } else {
            this.mobileFrom = false;
        }
      }
      onCloseLocation():void{
        this.mobileFrom = false;
      }
      

    createTravellerForm() {
        return this.fb.group({
            adults: 1,
            childrens: 0,
            childAges:this.fb.array([])
        });
    }

    setChildAgeArray(){
        return this.fb.group({
            childAge: 2,
        });  
      }
    travellers(controlName: string): FormArray {
        return this.regConfig.get(controlName) as FormArray;
    }

    addRoom() {
        if (this.regConfig.value['traveller'].length < 3) {
            this.noOfRooms++;
            this.noOfAdults++;
            this.travellers('traveller').push(this.createTravellerForm())
        }
    }

    removeRoom(i) {
        if (this.regConfig.value['traveller'].length > 0) {
            this.noOfRooms--;
            this.noOfAdults -= this.regConfig.value['traveller'][i]['adults'];
            this.noOfChild -= this.regConfig.value['traveller'][i]['childrens'];
            this.travellers('traveller').removeAt(i);
        }
    }

    onUpdateTraveller(i: any, travellerType: string, operation: string) {
        let traveller = this.travellers('traveller');
        let item = traveller.at(i);
        const adults = item.value['adults'];
        const childrens = item.value['childrens'];
        const control = traveller.controls[i]['controls'][travellerType];
        const childAge = item['controls']['childAges'] as FormArray;
        let result = 0;
        if (operation === 'minus') {
            result = control.value < 1 ? control.value : control.value - 1;
            if (travellerType == 'adults' && adults > 1) {
                this.noOfAdults -= 1;
            } else if (travellerType == 'childrens' && this.noOfChild >0 && control.value>0) {
                this.noOfChild -= 1;
                if(childAge.controls && childAge.controls.length>0){
                    let length=childAge.controls.length-1
                    childAge.removeAt(length);
                }
            }
        } else {
            result = control.value + 1;
        }
        let adultCount = 0, childCount = 0;
        if (travellerType == 'adults') {
            adultCount = adults;
            if (operation == 'plus' && adultCount <= 3) {
                this.noOfAdults += 1;
            }
        }
        if (travellerType == 'childrens') {
            childCount = childrens;
            if (operation == 'plus' && childCount <= 1) {
                this.noOfChild += 1;
                childAge.push(this.setChildAgeArray())
            }
        }
        if (operation === 'minus' && travellerType == 'adults' && result < 1) {
            return false;
        }
        if (adultCount > 3 && operation === 'plus') {
            this.travellerCountError = true;
            this.roomError = false;
            return false;
        }
        if (childCount > 1 && operation === 'plus') {
            this.travellerCountError = true;
            this.roomError = false;
            return false;
        }
        this.travellerCountError = false;
        control.setValue(result);
        // this.noOfAdults += this.regConfig.value['traveller'][i]['adults'];
        // this.noOfChild += this.regConfig.value['traveller'][i]['childrens'];
        this.regConfig.patchValue({
            traveller: [control]
        });
    }

    onSubmitTraveller() {
        this.travellersFadeinn = false;
    }

    closeTravellers() {
        this.travellersFadeinn = false;
    }


    hasError = (controlName: string, errorName: string) => {
        return ((this.submitted || this.regConfig.controls[controlName].touched) && this.regConfig.controls[controlName].hasError(errorName));
    }

    isOpenDropDown() {
        this.openRooms = !this.openRooms;
        return this.openRooms;
    }

    closeDropDown() {
        this.openRooms = false;
    }

    noOfNights(i, o,) {
        return String((new Date(o).getTime() - new Date(i).getTime()) / (1000 * 60 * 60 * 24)) + ' Nights'
    }


    onValueChange() {
        this.subSunk.sink = this.regConfig.valueChanges.subscribe(val => {
            if (val.checkinDate[0] instanceof Date) {
                let checkin = formatDate(this.regConfig.value.checkinDate[0], 'DD-MM-YYYY'); // String((<Date>this.regConfig.value.checkinDate[0]).toLocaleDateString());
                let checkout = formatDate(this.regConfig.value.checkinDate[1], 'DD-MM-YYYY'); // String((<Date>this.regConfig.value.checkinDate[1]).toLocaleDateString());
                this.regConfig.patchValue({ checkin, checkout, nights: this.noOfNights(this.util.formateDate(checkin), this.util.formateDate(checkout)) }, { emitEvent: false });
            }
        });
    }

    getAutoCompleteLocations(event) {
        let inpValue = event.target.value;
        this.locations.length = 0;
        if (inpValue.length > 0 && (event.timeStamp - this.lastKeyupTstamp > 10)) {
            this.isLoading = true;
            const city_name = `${event.target.value}`;
            this.apiHandlerService.apiHandler('cityList', 'POST', '', '', { city_name })
                .pipe(
                    tap(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe((resp: any) => {
                    if (resp.statusCode == 200) {
                        this.locations = resp.data;
                        this.cdr.detectChanges();
                    } else {
                        log.error('Something went wrong')
                    }
                }, err => { log.error(err) });
            this.lastKeyupTstamp = event.timeStamp;
        }
    }
    selectedLocation(location: any) {
        this.city = location;
        this.booking_source = location.booking_source;
    
        this.regConfig.patchValue({
            cityName: `${location.cityName} (${location.countryCode})`
        });
      
        this.locations = [];
        this.mobileFrom = false;
        this.checkinDate.nativeElement.focus();
        this.checkinDate.nativeElement.click();
        return;
    }

    validateLocation(typedLocation: string) {
        const matchingLocation = this.locations.find(location => location.cityName.toLowerCase() === typedLocation.toLowerCase());
        if (matchingLocation) {
            this.isValidLocation = true;
        } else {
            this.isValidLocation = false;
            this.regConfig.get('cityName')?.reset();
        }
    }

    resetValidLocation() {
        this.isValidLocation = false;
    }
    

    submitForm(data: any) {
        this.hotelService.hotelsCopy.next([]);
        this.hotelService.hotels.next([]);
        this.callResult.emit(data);
    }

    onSubmit() {
        console.log(this.regConfig.value, this.regConfig.value['traveller']);// return;
        this.submitted=true;
        if(!this.regConfig.valid){
            return;
        }
        const checkinDate = this.regConfig.value.checkin;
        const checkoutDate = this.regConfig.value.checkout;

        if (checkinDate.toISOString() === checkoutDate.toISOString()) {
            this.validationMsg = 'Check-in and Check-out dates cannot be the same.';
            return;
        }
        this.validationMsg = '';
        this.regConfig.patchValue({
            rate: this.starRating || null,  // Set star rating
            fromPrice: this.minValue || 1, // Set the minimum price
            toPrice: this.maxValue || 0    // Set the maximum price
        });
        this.hotelService.loading.next(true);
        this.submitSessionHotelSearchKeyCheck = true;
        if (this.city) {
            this.regConfig.value['destination_id'] = this.city;
            this.regConfig.value['destination_source'] = this.booking_source;
            // this.regConfig.value['rate'] = this.starRating > 0 ? this.starRating : null,
            // this.regConfig.value['fromPrice'] = this.minValue || 1;
            // this.regConfig.value['toPrice'] = this.maxValue || 0;
        }
        this.hotelService.formFilled.next(this.regConfig.value);
        sessionStorage.removeItem('hotelSearchData');
        sessionStorage.setItem('hotelSearchData', JSON.stringify(this.regConfig.value));
        sessionStorage.setItem('submitSessionHotelSearchKeyCheck', 'true');
        setTimeout(() => {
            this.isOpen = false;
            this.travellersFadeinn = false;
        }, 100);
            this.hotelService.isCollapsed.next(true);
            let RoomGuests = [];
            this.regConfig.controls.traveller.value.forEach(element => {
                RoomGuests.push({
                    "NoOfAdults": Number(element['adults']),
                    "NoOfChild": Number(element['childrens']),
                    "ChildAge": element['childAges']
                })
            });

            const formData = {
                // UserId: this.currentUser,
                UserType: "B2C",
                CheckIn: this.regConfig.value.checkin,
                CheckOut: this.regConfig.value.checkout,
                Currency: this.appGlobal.selectedCurrency.value,
                Market: this.regConfig.value.market,
                rate: this.starRating > 0 ? this.starRating : null, // Add star rating if available
                fromPrice: this.minValue || 1,    // Use price range values
                toPrice: this.maxValue || 0,
                CancellationPolicy: true,
                CityIds: [this.regConfig.value['destination_id']['cityId']],
                NoOfRooms: this.regConfig.value['traveller'].length,
                RoomGuests: RoomGuests,
                booking_source: this.booking_source
            };
            this.submitForm(formData);
            this.hotelService.formFilled.next(this.regConfig.value);

        this.prepareSearchPayloadFromSessionData('hotelSearchData');
        if (this.router.url == '/hotel-results') {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigateByUrl("/hotel-results");
        }
        else{
            this.router.navigateByUrl("/hotel-results");
        }
    }

    prepareSearchPayloadFromSessionData(sessionKey: string): any {
        const ssd = JSON.parse(sessionStorage.getItem(sessionKey));
        let RoomGuests = [];
        ssd['traveller'].forEach(element => {
            RoomGuests.push({
                "NoOfAdults": Number(element['adults']),
                "NoOfChild": Number(element['childrens']),
                "ChildAge":element['childAges']
            })
        });

        let reqBody = {
            "CheckIn": `${(moment(ssd['checkin'])).format('YYYY-MM-DD')}`,
            "CheckOut": `${moment(ssd['checkout']).format('YYYY-MM-DD')}`,
            "Currency": 'GBP',
            "Market": `${ssd['market']}`,
            "CancellationPolicy": true,
            "CityIds": [
                `${ssd['destination_id']['cityId']}`
            ],
            NoOfRooms: Number(ssd['traveller'].length),
            RoomGuests,
            rate: Number(ssd['rate']),
            fromPrice: Number(ssd['fromPrice']),
            toPrice: Number(ssd['toPrice']),
            booking_source: `${ssd['destination_source']}`
        }
        return reqBody;
    }


    clearDate() {
        console.log('Clear Date fuction called ');
        this.regConfig.patchValue({ checkinDate: '', checkin: '', checkout: '', nights: '' }, { emitEvent: false });
    }

    onDateChange(date: Date) {
        console.log(date);
    }

    onCheckIn(event) {
        if (event) {
            setTimeout(() => {
                this.checkoutDate.nativeElement.click();
                const eventDate = new Date(event);
                eventDate.setDate(eventDate.getDate() + 1);
                this.regConfig.patchValue({checkout: eventDate }, { emitEvent: false });
                this.setMinDate = eventDate; // Assuming setMinDate is a Date object
            }, 10)
        }
    }

    onCheckOut(event) {
        if (event) {
            setTimeout(() => {
                this.openRooms = true;
            }, 100)
        }
    }

    getAge(empIndex:number) : FormArray {
        return this.travellers('traveller').at(empIndex).get("childAges") as FormArray
    }
    onChange(value, index, ageIndex) {
        const childAges =this.getAge(index);
        childAges.controls[ageIndex].patchValue({ childAge: value });
    }
    
    setRoomUI(data1){
        if(data1 && data1.traveller){
            this.setAdultChildCount(data1.traveller);
            this.noOfRooms=0;
            this.noOfRooms=data1.traveller.length;
            if (data1['traveller'] && data1['traveller'].length > 1) {
                const traveller = this.regConfig.get('traveller') as FormArray;
                for (let i = 0; i < (data1['traveller'].length - 1); i++) {
                    traveller.push(this.createTravellerForm())
                }
            }
        }
    }
    
    setChildUI(data1) {
        if (data1['traveller'] && data1['traveller'].length) {
            const traveller = this.regConfig.get('traveller') as FormArray;
            for (let i = 0; i < data1['traveller'].length; i++) {
                const childAge = traveller.controls[i]['controls']['childAges'] as FormArray;
                for (let index= 0; index < data1['traveller'][i].childAges.length; index++) {
                    childAge.push(this.setChildAgeArray())
                }
            }
        }
    }

    setAdultChildCount(traveller){
        if(traveller){
        this.noOfAdults=0;
        this.noOfChild=0
            traveller.forEach(element => {
                this.noOfAdults += element.adults;
                this.noOfChild += element.childrens;
            });
        }
    }

    setModifySearch() {
        let data1 = sessionStorage.getItem('hotelSearchData');
        data1 = JSON.parse(data1) || [];
        if(data1){
            this.setRoomUI(data1);
            this.setChildUI(data1);
        }
        this.browserRefresh = browserRefresh;
        if (this.hotelService.formFilled || this.browserRefresh) {
            let data = sessionStorage.getItem('hotelSearchData');
            data = JSON.parse(data);
            if (data) {
                this.regConfig.patchValue({
                    cityName: data['cityName'],
                    checkin: new Date(data['checkin']),
                    checkout: new Date(data['checkout']),
                    checkinDate: new Date(data['checkinDate']),
                    traveller: data['traveller'],
                    countryCode: data['countryCode'],
                    guestNationality: data['guestNationality'],
                    destination_id: data['destination_id'],
                    destination_source: data1['destination_source'],
                    rate: data['rate'],
                    fromPrice: data['fromPrice'],
                    toPrice: data['toPrice'],
                });
            }
        }

        if (this.browserRefresh == false && data1.hasOwnProperty('destination_name')) {
            this.regConfig.patchValue({
                destination_name: data1['destination_name'],
                destination_id: data1['destination_id'],
                destination_source: data1['destination_source'],
                check_in_date: new Date(data1['check_in_date']),
                check_out_date: new Date(data1['check_out_date']),
                traveller: data1['traveller'],
                market:data1['market'],
                rate: data1['rate'],
                fromPrice: data1['fromPrice'],
                toPrice: data1['toPrice'],
            });
        }
        this.location.onPopState(() => {
            this.regConfig.patchValue({
                destination_name: data1['destination_name'],
                destination_id: data1['destination_id'],
                destination_source: data1['destination_source'],
                check_in_date: new Date(data1['check_in_date']),
                check_out_date: new Date(data1['check_out_date']),
                traveller: data1['traveller'],
                market:data1['market'],
                rate: data1['rate'],
                fromPrice: data1['fromPrice'],
                toPrice: data1['toPrice'],
            });

        });
        this.setAdultChildCount(this.regConfig.value['traveller']);
    }

    getMaxMinValues() {
        this.subSunk.sink = this.hotelService.minPrice.subscribe(min => {
            this.subSunk.sink = this.hotelService.maxPrice.subscribe(max => {
                this.min = Math.floor(min);
                this.max = Math.ceil(max) + 1;
                this.cdr.detectChanges();
                console.log(this.sliderRange);
                this.priceForm.patchValue({
                    min: this.min,
                    max: this.max,
                }, { emitEvent: false });
                this.isLoading = false;
                if (this.max > this.min)
                    this.sliderRange = [this.min, this.max];
                this.cdr.detectChanges();
            });
        });
        this.cdr.detectChanges();
    }

    createPriceForm(): void {
        this.priceForm = this.fb.group({
            min: new FormControl(this.min),
            max: new FormControl(this.max)
        })
    }

    onSliderChange(event) {
        this.priceForm.patchValue({
            min: event[0],
            max: event[1],
        }, { emitEvent: false });
        this.hotelService.myValue.next(event[1]);
        this.hotelService.myValueStart.next(event[0]);
        this.hotelService.changeSlider();
        this.cdr.detectChanges();
    }

    rangeChanged(r: any) {
        console.log("range...",r)
        this.hotelService.myValue.next(r[1]);
        this.hotelService.myValueStart.next(r[0]);
        this.hotelService.changeSlider();
        this.cdr.detectChanges();
    }

    valueChange(minVal){
        this.hotelService.myValueStart.next(minVal);
        this.hotelService.changeSlider();
        this.cdr.detectChanges();
    }
    highValueChange(maxVal){
        this.hotelService.myValue.next(maxVal);
        this.hotelService.changeSlider();
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.subSunk.unsubscribe();
    }
}
